import styled from 'styled-components';
import { PageHeader } from 'antd';
import { COLOR_NEUTRAL_10, COLOR_NEUTRAL_9 } from 'constants/colors';

export const StyledPageHeader = styled(PageHeader)`
  padding-left: 0;
  padding-right: 0;
  color: ${COLOR_NEUTRAL_10};

  & .ant-page-header-back-button {
    &:focus,
    &:hover {
      color: ${COLOR_NEUTRAL_9};
    }
  }
`;
